// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */
.chatbot-wrapper {
  max-width: 80%;
  margin: 40px auto;
  border: 1px solid #ccc;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 80vh;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.chatbot-title {
  background-color: #007bff;
  color: white;
  padding: 15px;
  text-align: center;
  margin: 0;
}

.chat-window {
  flex: 1 1;
  padding: 20px;
  overflow-y: auto;
  background: #f5f5f5;
}

.chat-bubble {
  max-width: 70%;
  padding: 10px 15px;
  margin: 8px 0;
  border-radius: 16px;
  word-wrap: break-word;
}

.chat-bubble.user {
  background-color: #d1e7dd;
  align-self: flex-end;
  margin-left: auto;
}

.chat-bubble.bot {
  background-color: #fff;
  align-self: flex-start;
  border: 1px solid #ccc;
}

.chat-bubble.typing {
  font-style: italic;
  opacity: 0.6;
}

.chat-input-container {
  display: flex;
  border-top: 1px solid #ccc;
  padding: 10px;
  background: white;
}

.chat-input {
  flex: 1 1;
  padding: 10px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-right: 10px;
}

.chat-send-btn {
  background-color: #007bff;
  color: white;
  padding: 0 20px;
  font-size: 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.outer-textare-inn{
width: 100%;
}

.file-ref-inner{
  display: flex;
  position: relative;
  top: -13px;
}
  
.field-input-inn{
  align-items: end;
  gap: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/chats/style.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;AACA,WAAW;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX","sourcesContent":["/* App.css */\n.chatbot-wrapper {\n  max-width: 80%;\n  margin: 40px auto;\n  border: 1px solid #ccc;\n  border-radius: 12px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  height: 80vh;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.1);\n}\n\n.chatbot-title {\n  background-color: #007bff;\n  color: white;\n  padding: 15px;\n  text-align: center;\n  margin: 0;\n}\n\n.chat-window {\n  flex: 1;\n  padding: 20px;\n  overflow-y: auto;\n  background: #f5f5f5;\n}\n\n.chat-bubble {\n  max-width: 70%;\n  padding: 10px 15px;\n  margin: 8px 0;\n  border-radius: 16px;\n  word-wrap: break-word;\n}\n\n.chat-bubble.user {\n  background-color: #d1e7dd;\n  align-self: flex-end;\n  margin-left: auto;\n}\n\n.chat-bubble.bot {\n  background-color: #fff;\n  align-self: flex-start;\n  border: 1px solid #ccc;\n}\n\n.chat-bubble.typing {\n  font-style: italic;\n  opacity: 0.6;\n}\n\n.chat-input-container {\n  display: flex;\n  border-top: 1px solid #ccc;\n  padding: 10px;\n  background: white;\n}\n\n.chat-input {\n  flex: 1;\n  padding: 10px;\n  font-size: 16px;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  margin-right: 10px;\n}\n\n.chat-send-btn {\n  background-color: #007bff;\n  color: white;\n  padding: 0 20px;\n  font-size: 16px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.outer-textare-inn{\nwidth: 100%;\n}\n\n.file-ref-inner{\n  display: flex;\n  position: relative;\n  top: -13px;\n}\n  \n.field-input-inn{\n  align-items: end;\n  gap: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
